export default class CouponsDataProvider {
  constructor(Coupons) {
    "ngInject"
    this.CouponsService = Coupons;
  }

  getCoupons(data) {
    return this.CouponsService.loadCoupons(data)
      .then((result) => {
        return result;
      })
  }

  getCoupon(id) {
    return this.CouponsService.getCoupon(id)
      .then((result) => {
        return result;
      })
  }

  updateCoupon(data, id) {
    return this.CouponsService
      .updateCoupon(data, id)
      .then((resp) => {
        return resp;
      })
  }

  updateCouponStatus(data) {
    return this.CouponsService
      .updateCouponStatus(data)
      .then((resp) => {
        return resp;
      })
  }

  removeCoupon(id) {
    return this.CouponsService
      .removeCoupon(id)
      .then((resp) => {
        return resp;
      })
  }

  createCoupon(data) {
    return this.CouponsService
      .createCoupon(data)
      .then((resp) => {
        return resp;
      })
  }


}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/coupons/services/coupon.dataprovider.service.js
 **/